import {
  useState,
} from 'react';

function useIconInformation() {

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {

    setIsModalVisible(true);

  };

  const handleOk = () => {

    setIsModalVisible(false);

  };

  const handleCancel = () => {

    setIsModalVisible(false);

  };
  return {
    isModalVisible,
    setIsModalVisible,
    showModal,
    handleOk,
    handleCancel,
  };

}

export default useIconInformation;
